import { useMemo } from 'react';

import { useTheme } from '@zenbusiness/zui/styles';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

export default function useBreakpoints() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const sizes = useMemo(
    () => ({
      isDesktop,
      isMobile,
      isTablet
    }),
    [isMobile, isTablet, isDesktop]
  );

  return { sizes, theme };
}
